module.exports = "import React from 'react';\nimport DatePicker from 'material-ui/DatePicker';\n\n/**\n * The Date Picker defaults to a portrait dialog. The `mode` property can be set to `landscape`.\n * You can also disable the Dialog passing `true` to the `disabled` property.\n */\nconst DatePickerExampleSimple = () => (\n  <div>\n    <DatePicker hintText=\"Portrait Dialog\" />\n    <DatePicker hintText=\"Landscape Dialog\" mode=\"landscape\" />\n    <DatePicker hintText=\"Dialog Disabled\" disabled={true} />\n  </div>\n);\n\nexport default DatePickerExampleSimple;\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/app/components/pages/components/DatePicker/ExampleSimple.js
 ** module id = 960
 ** module chunks = 0
 **/